/**
 * Hide the cart badge when the cart is empty. Liquid sets .bx-cart-empty on first render;
 * the theme later only rewrites the number inside #cart-count, so watch that text.
 */
export function initCartCount() {
  const count = document.getElementById('cart-count');
  if (!count) return;
  const update = () => {
    count.classList.toggle('bx-cart-empty', (parseInt(count.textContent, 10) || 0) === 0);
  };
  update();
  new MutationObserver(update).observe(count, { childList: true, characterData: true, subtree: true });
}
